export const EXTERNAL_ROUTES = {
  BIENESTAR_NET_BOOK: 'https://ai.unirmentes.com/es/bienestar-net/book',
  BIENESTAR_NET_CAMPAIGN: 'https://ai.unirmentes.com/es/bienestar-net/campaign',
};
